import React from 'react';
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="footer px-2 py-2">
      <div className="d-flex justify-content-around">
        <Link to="/terms-of-service" className="txt-warning d-block text-center">
          Terms of service
        </Link>
        <Link to="/disclaimer" className="txt-warning d-block text-center">
          Disclaimer
        </Link>
      </div>
    </div>
  );
}

export default Footer;
